import { ASSIGNMENT_POLICY_UI_ENABLED } from 'dashboard/routes/dashboard/settings/assignmentPolicy/assignmentPolicyVisibility';

// Item "Atribuição de agentes" das Configurações (Atribuição V2).
// Devolve uma lista para ser espalhada nos filhos de Configurações: vazia
// enquanto a tela estiver escondida (ver assignmentPolicyVisibility.js).
export function buildAssignmentPolicyMenu({
  t,
  accountScopedRoute,
  enabled = ASSIGNMENT_POLICY_UI_ENABLED,
}) {
  if (!enabled) return [];
  return [
    {
      name: 'Settings Agent Assignment',
      label: t('SIDEBAR.AGENT_ASSIGNMENT'),
      icon: 'i-lucide-user-cog',
      to: accountScopedRoute('assignment_policy_index'),
    },
  ];
}
